import { schema, types } from 'papr'

export const seriesSchema = schema(
	{
		name: types.string({ required: true }),
		cuid: types.string(),
		slug: types.string({ required: true }),
		brief: types.string(),
		description: types.string(),
		descriptionMarkdown: types.string(),
		coverImage: types.string(),
		author: types.objectId({ required: true }),
		posts: types.array(types.objectId()),
		numPosts: types.number(),
		dateAdded: types.date(),
		isDelisted: types.boolean(),
		isActive: types.boolean(),
		sortOrder: types.enum(['asc' as const, 'dsc' as const]),
		// TODO: to be retired
		partOfPublication: types.boolean(),
		publication: types.objectId(),
		movedToBlog: types.boolean(),
	},
	{
		timestamps: true,
		defaults: {
			numPosts: 0,
			isDelisted: false,
			isActive: true,
			sortOrder: 'asc' as const,
			partOfPublication: false,
			movedToBlog: false,
		},
	},
)

export type SeriesDocument = (typeof seriesSchema)[0]
export type SeriesSchemaOptions = (typeof seriesSchema)[1]
